import { UUID } from '@indigohive/cogfy-types'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useCogfy, useWorkspaceSlug } from '../../hooks'
import { Breadcrumbs, ChatEngineTraceViewer, FormattedDate, Navbar } from '../../components'
import { MessageSquareIcon, MessagesSquareIcon } from 'lucide-react'

export function ChatMessagePage () {
  const params = useParams<{ chatMessageId: UUID }>()
  const chatMessageId = params.chatMessageId!

  const workspace = useWorkspaceSlug()
  const cogfy = useCogfy()
  const getChatMessage = useQuery({
    queryKey: ['getChatMessageById', { chatMessageId }] as const,
    queryFn: ({ queryKey, signal }) => cogfy.getChatMessageById(queryKey[1], { signal })
  })
  const chatMessage = getChatMessage.data

  return (
    <div className="h-screen flex flex-col">
      <Navbar>
        <Breadcrumbs
          items={[
            {
              label: 'Chat',
              icon: <MessagesSquareIcon size={16} />,
              to: `/${workspace}/chats/${chatMessage?.chatId}`
            },
            {
              label: 'Message',
              icon: <MessageSquareIcon size={16} />
            }
          ]}
        />
      </Navbar>
      {getChatMessage.isLoading && <progress className="progress w-full" />}
      {chatMessage && (
        <div className="bg-base-100 px-8 py-4 flex gap-4 h-full overflow-y-hidden">
          <div className="w-3/4">
            {chatMessage.trace?.data && (
              <ChatEngineTraceViewer trace={chatMessage.trace.data as any} />
            )}
            {!chatMessage.trace?.data && (
              <div className="text-sm opacity-70">No trace found</div>
            )}
          </div>
          <div className="w-1/4 break-words text-sm overflow-y-auto rounded-md p-4 shadow-md bg-base-200" style={{ scrollbarWidth: 'thin' }}>
            {chatMessage.status && <div><span className='font-bold text-base'>Status: </span>{chatMessage.status}</div>}
            <div><span className='font-bold text-base'>Role: </span>{chatMessage.role}</div>
            <div><span className='font-bold text-base'>Content type: </span>{chatMessage.contentType}</div>
            <div><span className='font-bold text-base'>Content: </span>{chatMessage.content}</div>
            <div><span className='font-bold text-base'>Send date: </span><FormattedDate date={chatMessage.sendDate} format="Ppp" /></div>
            <div><span className='font-bold text-base'>Update date: </span><FormattedDate date={chatMessage.updateDate} format="Ppp" /></div>
            {chatMessage.scheduleDate && (
              <div><span className='font-bold text-base'>Schedule date: </span><FormattedDate date={chatMessage.scheduleDate} format="Ppp" /></div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
